import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { NaturezaVendaPipeModule } from '../../natureza-venda/pipes';
import { NaturezaVendaTypeaheadModule } from '../../natureza-venda/typeahead';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { UnidadeNegocioNaturezaVendaComponent } from './unidade-negocio-natureza-venda.component';
import { UnidadeNegocioNaturezaVendaFilterPipe, UnidadeNegocioNaturezaVendaSituacaoFilterPipe } from './pipes';
import { UnidadeNegocioNaturezaVendaMultiselectComponent } from './multiselect';

@NgModule({
    imports: [
        SharedModule,
        NaturezaVendaPipeModule,
        NaturezaVendaTypeaheadModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        UnidadeNegocioNaturezaVendaComponent,
        UnidadeNegocioNaturezaVendaMultiselectComponent,
        UnidadeNegocioNaturezaVendaFilterPipe,
        UnidadeNegocioNaturezaVendaSituacaoFilterPipe
    ],
    exports: [
        UnidadeNegocioNaturezaVendaComponent,
        UnidadeNegocioNaturezaVendaMultiselectComponent,
        UnidadeNegocioNaturezaVendaFilterPipe,
        UnidadeNegocioNaturezaVendaSituacaoFilterPipe
    ],
    providers: [
        UnidadeNegocioNaturezaVendaFilterPipe,
        UnidadeNegocioNaturezaVendaSituacaoFilterPipe
    ]
})
export class UnidadeNegocioNaturezaVendaModule { }
